import React from "react";
import "./Footer.scss";
const Footer = () => {
  return (
    <div className="footer">
      <p>
        &copy; 2021 <a href="https://twitter.com/TagraSahab">Sahil Tagra</a>
      </p>
    </div>
  );
};

export default Footer;
